<template>
  <div>
    <div class="learning-content">
      <div class="step-wrap">
        <ul>
          <li v-for="(year, index) in activeData" :key="year.year"
            class="step-item animate__animated animate__fadeInLeft" @click="scroolIntoView(index)">
            <div class="icon-wrap">
              <img src="@/assets/image/step_icon.png" alt="" class="step-icon" />
            </div>
            <span class="year">{{ year.year }}</span>
          </li>
        </ul>
      </div>
      <div>
        <ul class="article-wrap" id="article-wrap">
          <li class="article-item animate__animated"
            :class="[activeData.type === 'zl' ? 'animate__fadeIn' : 'animate__lightSpeedInRight']"
            v-for="(year, index) in activeData" :key="year.year" :id="'article-item' + index">
            <span class="year">{{ year.year }}</span>
            <ul>
              <li v-for="(article, count) in year.datas" :key="count" class="article-info">
                 <span class="article-name">{{ article.title }}</span>
                  <span class="author">{{ article.author }}</span>
                  <img :src="article.image" alt="" class="article-img" @click="showLargeImg(article)" />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <img :src="largeImg" alt="" style="width:100%">
    </el-dialog>
  </div>
</template>

<script>
  import data from "@/mock/sign.json";
  export default {
    data() {
      return {
        dataList: data,
        largeImg: "",
        dialogTitle: "",
        dialogVisible: false,
        activeData: {}
      };
    },
    created() {
      this.activeData = data;
      console.log(this.activeData)
    },
    methods: {
      scroolIntoView(index) {
        this.$nextTick(_ => {
          const parentElem = document.getElementById("article-wrap");
          const elem = document.getElementById("article-item" + index);
          // const top = elem.offsetTop
          parentElem.scrollTop = elem.offsetTop;
          // elem.scrollIntoView();
        });
      },
      showLargeImg(row) {
        this.largeImg = row.image;
        this.dialogTitle = row.title;
        this.dialogVisible = true;
      }
    }
  };

</script>

<style lang="scss">
  .sub-nav {
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    line-height: 48px;

    .sub-nav-item {
      width: 200px;
      background: #f5f7fa;
      margin-right: 10px;
      cursor: pointer;

      &.cu {
        background: #66b1ff;
        color: #fff;
      }

      &:not(.cu):hover {
        background: #66b1ff;
        color: #fff;
      }
    }
  }

  .learning-content {
    display: flex;
    padding-top: 30px;

    .step-wrap {
      width: 200px;
      padding: 10px 0 0 20px;
      height: 100vh;
      overflow-y: scroll;

      .step-icon {
        width: 32px;
        height: 32px;
      }

      .step-item {
        display: flex;
        align-items: center;
        padding-bottom: 50px;

        .year {
          color: #f56c6c;
          font-style: italic;
          font-family: "Times New Roman", Georgia, Serif;
          font-weight: bold;
          font-size: 20px;
          margin-left: 5px;
          cursor: pointer;

          &:hover {
            transform: scale(1.5);
            transition: all 0.5s;
          }
        }

        .icon-wrap {
          width: 32px;
          height: 32px;
          position: relative;

          &::after {
            content: " ";
            position: absolute;
            left: 50%;
            bottom: -50px;
            height: 50px;
            border-left: 2px dashed #90b0d2;
          }
        }
      }
    }

    .article-wrap {
      color: #333;
      height: 100vh;
      overflow-y: scroll;
      position: relative;
      scroll-behavior: smooth;

      .year {
        line-height: 48px;
        font-size: 16px;
        color: #999;
      }

      .article-info {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 28px;
        list-style: initial;

        .author {
          margin-left: 10px;
          color: #999;
        }

        .article-img {
          height: 50px;
          margin: 10px;
          cursor: pointer;
        }
      }
    }

    .awards-wrap{
      width: 1200px;
      text-align: center;
      .awards-img{
        width: 408px;
        height: auto;
        cursor: pointer;
      }
      .awards-name{
        font-size: 16px;
        color: #333;
      }
    }

    .book-wrap{
      margin-bottom: 30px;
      .book-img{
        width: 100px;
        height: auto;
        cursor: pointer;
        border: 1px solid #eee;
      }
      .book-name{
        font-size: 14px;
        color: #333;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/components/meeting_sign.vue